var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5833 10.0833H13.9167V2.41667C13.9167 1.90834 13.7147 1.42082 13.3553 1.06138C12.9958 0.701934 12.5083 0.5 12 0.5C11.4917 0.5 11.0042 0.701934 10.6447 1.06138C10.2853 1.42082 10.0833 1.90834 10.0833 2.41667V10.0833H2.41667C1.90834 10.0833 1.42082 10.2853 1.06138 10.6447C0.701934 11.0042 0.5 11.4917 0.5 12C0.5 12.5083 0.701934 12.9958 1.06138 13.3553C1.42082 13.7147 1.90834 13.9167 2.41667 13.9167H10.0833V21.5833C10.0833 22.0917 10.2853 22.5792 10.6447 22.9386C11.0042 23.2981 11.4917 23.5 12 23.5C12.5083 23.5 12.9958 23.2981 13.3553 22.9386C13.7147 22.5792 13.9167 22.0917 13.9167 21.5833V13.9167H21.5833C22.0917 13.9167 22.5792 13.7147 22.9386 13.3553C23.2981 12.9958 23.5 12.5083 23.5 12C23.5 11.4917 23.2981 11.0042 22.9386 10.6447C22.5792 10.2853 22.0917 10.0833 21.5833 10.0833Z",
    fill: "#526F65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.2265bdde9a92d71f11ba104d75421287.svg";
export { ForwardRef as ReactComponent };